import VFooter from './VFooter'

/* istanbul ignore next */
VFooter.install = function install (Vue) {
  Vue.component(VFooter.name, VFooter)
}

export { VFooter }
export default VFooter
